
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    modelValue: Boolean,
    label: String
  }
})
export default class BaseCheckbox extends Vue {
  modelValue!: boolean
  label!: string

  get internalValue(): boolean {
    return this.modelValue
  }

  set internalValue(value: boolean) {
    this.$emit('update:modelValue', value)
  }
}
